import * as yup from "yup";
import { alphaNumericPattern, emailrgx } from "../assets/constant";
export const schema = (t) =>
  yup
  .object({
    name: yup
      .string()
      .trim()
      .matches(alphaNumericPattern, t("Please enter a valid name"))
      .required(t("Please enter your name")),
      email: yup
      .string()
      .email(t("Invalid email format")) // Use built-in email validation
      .required(t("Email is required"))
      .trim(),

      phone: yup.string().trim().matches(/^\+\d{1,4}\d{6,14}$/, t("Please enter a valid international phone number that starts with +")).required(t("Contact number is required")),

      password1: yup
      .string()
      .min(6, t("Password must be at least 6 characters"))
      .required(t("Password is required"))
      .trim(),

      password2: yup
      .string()
      .oneOf([yup.ref("password1")], t("Passwords must match"))  // Correct reference
      .required(t("Confirm password is required")),



  })
  .required();